import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsConditions() {
  return (
    <div data-testid="terms-conditions-page" className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-slate-50 border-b border-slate-100">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl py-6">
          <Link
            to="/"
            data-testid="back-to-home"
            className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 transition-colors font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 md:px-6 max-w-4xl py-12">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-8">
          Terms & Conditions
        </h1>

        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-6">
            <strong>Last Updated:</strong> December 2025
          </p>

          <p className="text-slate-600 mb-6">
            Welcome to Cozy Nests. By using our services, you agree to the following terms and conditions.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Services
          </h2>
          <p className="text-slate-600 mb-6">
            We provide professional pet grooming services for dogs and cats. Service pricing varies based on breed, size, and coat condition. A transparent quote will be provided before any service begins.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Appointments
          </h2>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Appointments are scheduled based on availability.</li>
            <li>We recommend booking in advance, especially during peak seasons.</li>
            <li>Please arrive on time for your scheduled appointment.</li>
            <li>Late arrivals may result in shortened service time or rescheduling.</li>
          </ul>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Pet Health & Safety
          </h2>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Pets must be current on vaccinations for the safety of all animals and staff.</li>
            <li>Please inform us of any health conditions, allergies, or behavioral concerns.</li>
            <li>We reserve the right to refuse service to aggressive pets for safety reasons.</li>
            <li>If we discover any health issues during grooming, we will inform you immediately.</li>
          </ul>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Payment
          </h2>
          <p className="text-slate-600 mb-6">
            Payment is due at the time of service. We accept cash, credit cards, and debit cards.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Liability
          </h2>
          <p className="text-slate-600 mb-6">
            While we take every precaution to ensure your pet's safety, grooming carries inherent risks. We are not liable for pre-existing conditions, accidents, or illnesses that may occur after grooming services.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Contact Us
          </h2>
          <p className="text-slate-600 mb-4">
            If you have questions about these Terms & Conditions, please contact us at:
          </p>
          <div className="text-slate-600 mb-8">
            <p><strong>Cozy Nests</strong></p>
            <p>20 E 22nd St #4699, New York, NY 10165</p>
            <p>Phone: +1-888-8801-344</p>
            <p>Email: bookings@cozynests.store</p>
          </div>
        </div>
      </main>
    </div>
  );
}
